import React from 'react';
import { NodeResizer } from '@xyflow/react';
import styles from '../style.module.css';
import { Divider, Typography } from '@mui/material';

function AgeRangeNode({ data }) {
  return (
    <div className={styles.ageRangeNode}>
      <NodeResizer minWidth={180} minHeight={100} />
      <Typography align="center" fontSize="8px">{data?.label}</Typography>
      <Divider />
    </div>
  );
}

export default React.memo(AgeRangeNode);
